import { MakeCall } from 'ha/services/apiV2/createMakeCall';
// eslint-disable-next-line sort-imports
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (
  conversationId: number,
  messageId: number,
) =>
  makeCall<undefined>(
    'DELETE',
    `${APIV2_URL}/conversation/${conversationId}/message/${messageId}`,
  );
